import { createDocument, getDocuments, updateDocument } from '../services/documents';
import { ChargePointGroupsProps } from '../types/responses/ChargePointGroups';

const createChargePointGroup = async (chargepointGroup) => {
  const data = await createDocument(chargepointGroup, 'chargepoint-groups');
  return data;
};

const updateChargePointGroup = async (chargepointGroup, chargeBoxGroupPk) => {
  const data = await updateDocument(chargeBoxGroupPk, chargepointGroup, 'chargepoint-groups');
  return data;
};

const getChargePointGroups = async (): Promise<ChargePointGroupsProps> => {
  const data: any = await getDocuments('chargepoint-groups');
  return data;
};

const getChargePointGroupDetail = async (chargeBoxGroupPk) => {
  const data = await getDocuments(`chargepoint-groups/${chargeBoxGroupPk}`);
  return data;
};

export { getChargePointGroups, createChargePointGroup, updateChargePointGroup, getChargePointGroupDetail };
